import { GET_GARMENT_WASH_FAILURE, GET_GARMENT_WASH_SUCCESS } from '../constants/MTag';
import { onSuccess, onFailure } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_GARMENT_WASH_SUCCESS:
			return onSuccess(state, action);
		case GET_GARMENT_WASH_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
